__turbopack_context__.v({
  "body": "D-PLNG_body",
  "card": "D-PLNG_card",
  "date": "D-PLNG_date",
  "imageBadge": "D-PLNG_imageBadge",
  "imageWrap": "D-PLNG_imageWrap",
  "imageWrapMuted": "D-PLNG_imageWrapMuted",
  "link": "D-PLNG_link",
  "poster": "D-PLNG_poster",
  "price": "D-PLNG_price",
  "stickerBottomLeft": "D-PLNG_stickerBottomLeft",
  "tagTopLeft": "D-PLNG_tagTopLeft",
  "tagTopRight": "D-PLNG_tagTopRight",
  "title": "D-PLNG_title",
  "venue": "D-PLNG_venue",
});
